import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconInfoCircle } from "@tabler/icons-react";

interface ValidationSuccessBannerProps {
  projectsCount: number;
  environmentsCount: number;
  onViewDetails: () => void;
}

const ValidationSuccessBanner = ({
  projectsCount,
  environmentsCount,
  onViewDetails,
}: ValidationSuccessBannerProps): JSX.Element => {
  return (
    <div className="al-bg-blue-50 al-border al-border-blue-200 al-rounded al-p-4">
      <Stack direction="row" align="center" gap="sm">
        <IconInfoCircle size={20} className="al-text-blue-600 al-flex-shrink-0" />
        <Typography size="sm">
          <span className="al-font-semibold">{projectsCount} Project{projectsCount !== 1 ? "s" : ""}</span>
          {" "}and{" "}
          <span className="al-font-semibold">{environmentsCount} Environment{environmentsCount !== 1 ? "s" : ""}</span>
          {" "}added. Click{" "}
          <button
            type="button"
            onClick={onViewDetails}
            className="al-text-primary al-underline al-cursor-pointer al-font-medium"
          >
            here
          </button>
          {" "}to view details.
        </Typography>
      </Stack>
    </div>
  );
};

export default ValidationSuccessBanner;
